module.exports = __webpack_public_path__ + "img/ic-notransport.5b14e105.svg";